<!--<div id="container" style="height: 500px;"></div>-->


<ng-container *ngIf="chartOptions">
    <highcharts-chart
            id="container"
            [Highcharts]="Highcharts"
            [constructorType]="chartConstructor"
            [options]="chartOptions"
            style="width: 100%; min-height: 65vh; display: block;"
    >
    </highcharts-chart>
</ng-container>